import React from "react";
import Navigation from '../components/Navigation/Navigation';
import GlobalStyle from '../assets/styles/globalStyles';
import Form from '../components/Form/Form';
import Footer from '../components/Footer/Footer';
import SEO from "../components/seo";
import { Helmet } from "react-helmet";

import favIcon from '../assets/images/favicon/favicon.ico';

const MainLayout = ({children}) => (
    <>
        <GlobalStyle/>
        <Navigation/>
        <Helmet>
        <link rel="icon" href={favIcon} />
        </Helmet>
        {children}
        <Form id="kontakt"/>
        <Footer />
    </>
)

export default MainLayout